import { Component, input } from '@angular/core';
import { UIIconsComponent } from "../../ui/icons/icons.component";

@Component({
  selector: 'app-agent-trigger',
  standalone: true,
  imports: [UIIconsComponent],
  templateUrl: './agent-trigger.component.html',
})
export class AgentTriggerComponent {
  public title = input('Build using natural language')
}
